export abstract class UserRoles {
    public static readonly eurofinsSuperUser: string = 'EurofinsSuperUser';
    public static readonly roleUnassigned: string = 'RoleUnassigned';
}
